/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Locations API
 * AV Services Locations management API
 * OpenAPI spec version: 1.0
 */

export interface DevicesByStatuses {
  /** Number of active devices */
  activeCount: number;
  /** Number of archived devices */
  archivedCount: number;
  /** Number of deactivated devices */
  deactivatedCount: number;
  /** Number of paused devices */
  pausedCount: number;
}
